module.exports = __webpack_public_path__ + "img/img40.e794adf6.png";